import {
  primaryColor,
  dangerColor,
  successColor,
  defaultFont,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";

const customInputStyle = {
  disabled: {
    backgroundColor: grayColor[0],
    cursor: "not-allowed",
    "& input": {
      color: grayColor[5],
    },
  },
  underline: {
    "&:before, &:after": {
      display: "none",
    },
  },
  underlineError: {
    "&:after": {
      borderColor: dangerColor[0],
    },
  },
  underlineSuccess: {
    "&:after": {
      borderColor: successColor[0],
    },
  },
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    top: "10px",
    letterSpacing: "unset",
    "& + $underline": {
      marginTop: "0px",
    },
  },
  labelRootError: {
    color: dangerColor[0] + " !important",
  },
  labelRootSuccess: {
    color: successColor[0] + " !important",
  },
  formControl: {
    margin: "0 0 17px 0",
    position: "relative",
    verticalAlign: "unset",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: grayColor[14],
    },
  },
  whiteUnderline: {
    "&:hover:not($disabled):before,&:before": {
      backgroundColor: whiteColor,
    },
    "&:after": {
      backgroundColor: whiteColor,
    },
  },
  input: {
    color: grayColor[14],
    padding: 0,
    "&,&::placeholder": {
      fontSize: "16px",
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: "400",
      lineHeight: "1.5",
      opacity: "1",
    },
  },
  whiteInput: {
    "&,&::placeholder": {
      color: whiteColor,
      opacity: "1",
    },
  },
  labelRTL: {
    right: 0,
    transition: "all 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
    "&.MuiInputLabel-shrink": {
      transform: "translate(0, 1.5px)",
      fontSize: "10px",
    },
  },
  inputRoot: {
    backgroundColor: "#d9d9d9",
    borderRadius: "6px",
    padding: "10px 12px",
    border: `1px solid ${grayColor[5]}`,
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    marginLeft: "10px",
    "&:hover": {
      borderColor: grayColor[6],
    },
  
    "&.Mui-focused": {
      borderColor: primaryColor[0],
      boxShadow: `0 0 0 2px ${primaryColor[0]}22`,
    },
  
    "&.Mui-error": {
      borderColor: dangerColor[0],
    },
  
    "&.Mui-disabled": {
      backgroundColor: grayColor[0],
      borderColor: grayColor[0],
      cursor: "not-allowed",
    },
  },
};

export default customInputStyle;
